"use client";

import { usePathname } from "next/navigation";

import { SidebarTrigger } from "@/components/ui/sidebar";
import { CONSOLE_TABS } from "@/lib/navigation";

// Titles derive from the shared nav table; /settings is the one header-only
// route (it has no sidebar tab).
function titleFor(pathname: string): string {
  if (pathname.startsWith("/settings")) return "Settings";
  const tab = CONSOLE_TABS.find((t) =>
    t.href === "/" ? pathname === "/" : pathname.startsWith(t.href),
  );
  return tab?.title ?? "";
}

export function ConsoleHeader() {
  const pathname = usePathname();
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4">
      <SidebarTrigger className="-ml-1" />
      {/* Not the Separator component: its data-vertical variant classes
          out-cascade size overrides, and this line is purely decorative. */}
      <div aria-hidden className="mr-1 h-4 w-px bg-border" />
      <h1 className="font-medium text-sm">{titleFor(pathname)}</h1>
    </header>
  );
}
